module.exports = __webpack_public_path__ + "static/media/logo.b0779003.png";